// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"474":"83a9b394","594":"ba6d6720","897":"f11206ce","942":"a45ccec2"}[chunkId] + ".js";
};